function changeOnlineStatus(command, e){
    let that = e;
    let m="";
    if(9 == command){
        m="上线";
    }else if(1 == command){
        m="下线";
    }
    if(that.selectedDataKeys.length === 0){
        that.$message.error("请先选择要批量"+m+"的数据");
    }else{
        that.batchAuditModel.ids=that.selectedDataKeys;
        that.batchAuditModel.type=1;//操作类型。0：审核操作  1：上下线操作
        that.batchAuditModel.batchAuditStatus=command;
        that.$confirm('确定批量'+m+'选中数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            batchAudit(that);
        })
    }
};
function batchAudit(e) {
    let that = e;
    let successMsg="";
    let formData = {
        status: that.batchAuditModel.batchAuditStatus,
        msg: that.batchAuditModel.batchMsg,
        ids: that.batchAuditModel.ids,
        type:1,
        classPrefixName:that.batchAuditModel.classPrefixName,//要操作的对象类前缀，例如：Scenic | Poi
        hasAudit:that.batchAuditModel.hasAudit,
    };
    that.request.put("/wtcp-bics/common/batchChangeStatus", formData).then(res => {
        that.pageload = false;
        if (res.status == 1) {
            if(that.batchAuditModel.type==1&&that.batchAuditModel.batchAuditStatus==9){
                successMsg="批量上线成功!";
            }else if(that.batchAuditModel.type==1&&that.batchAuditModel.batchAuditStatus==1){
                successMsg="批量下线成功!";
            }
            that.$message.success(res.msg == "success" ? successMsg : res.msg);
            that.batchAuditModelSync = false;
            that.batchAuditModel={
                ids: [],
                batchAuditStatus: 1,
                batchMsg: "",
                type:"",//操作类型。0：审核操作  1：上下线操作
                classPrefixName:"",//要操作的对象类前缀，例如：Scenic | Poi,
                hasAudit:that.batchAuditModel.hasAudit
            }
            that.refreshPage();
        } else {
            that.$message.error({
                content: "提交失败，原因：" + res.msg,
                duration: 6,
                closable: true
            });
        }
    });
};
export default changeOnlineStatus;